import script from "./RecipeDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecipeDetail.vue?vue&type=script&setup=true&lang=ts"

import "./RecipeDetail.vue?vue&type=style&index=0&id=0eb1f6b5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eb1f6b5"]])

export default __exports__